import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Spinner,
  Table
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
//import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as savePhotoAction from "../../store/Z2V0UGhvdG9/actions"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import moment from "moment"
import api from "helpers/Api"

const GetPhotographerAppDetails = (props) => {
  const { dispatch, searchBtnStyle } = props

  const title = "Get Photographer App Details"


  //Fetching API
  useEffect(() => {
    dispatch(savePhotoAction.loadRecordsMetaData())
    dispatch(
      savePhotoAction.loadPhoto({
        page: 1,
        limit: 50,

      })
    )
  }, [])

  //date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""


  const update = useSelector((specificstate) => specificstate.getPhotographerAppDetails)

  const { photo_data = [], recordsMetaData = {} } = update

  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)

  //Handle Change

  const [event, setEvent] = useState([])
  //Handle Change
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )

  const [photoData, setPhotoData] = useState({
    leadNo: "",
    eventFromDate: "",
    eventToDate: "",
  })

  const handleChange = (e) => {
    setPhotoData({ ...photoData, [e.target.name]: e.target.value })
  }


  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [downloadLoading, setDownloadLoading] = useState(false)
//branch & event values
const branches = !isEmpty(branch) && branch.map((branch) => branch.value)
const events = !isEmpty(event) && event.map((m) => m.value)
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = company && company ? company.value : ""
    var searchBranch = branch && branch ? branches : ""
    var searchLeadNo = photoData && photoData ? photoData.leadNo : ""
    var searchEvent = event && event ? events : ""
    var searchFromDate =
      photoData && photoData.eventFromDate
        ? moment(photoData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      photoData && photoData.eventToDate
        ? moment(photoData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    setPageLoad(!pageLoad)
    //  setSearchValueList(searchvalue)
    dispatch(savePhotoAction.loadPhoto(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  //reset

  const resetForm = () => {
    setEvent([])
    setCompany([])
    setSearchInput("")
    setBranch([])
    setPhotoData({
      ...photoData,
      leadNo: "",
      eventFromDate: "",
      eventToDate: "",
    })

    dispatch(
      savePhotoAction.loadPhoto({
        page: 1,
        limit: 50,
      })
    )
  }

  const [attachmentModal, setAttachmentModal] = useState(false)
  const [attachmentDetails, setAttachmentDetails] = useState("")

  const [clientAttachmentModal, setClientAttachmentModal] = useState(false)
  const [clientAttachmentDetails, setClientAttachmentDetails] = useState("")

 

  const [freelancerModal, setFreelancerModal] = useState(false)
  const [freelancerData, setFreelancerData] = useState("")

  const photoTable = !isEmpty(photo_data) ? photo_data.data.map((data, index) => {

    const eventIssuesFeedback = !isEmpty(data.eventIssue) ? data.eventIssue.map(m => m.remarks).join(",") : "--"
    const eventAttachment = !isEmpty(data.eventIssue) ? data.eventIssue[0].attachment : []

    const checkinDate = data.PhotographerCheckInDateTime
      ? moment(data.PhotographerCheckInDateTime)
      : ""
    // const checkinDate = moment(
    // "2023-11-27T06:18:09.000Z")
    const checkoutDate = data.PhotographerCheckOutDateTime
      ? moment(data.PhotographerCheckOutDateTime)
      : ""
    // const checkoutDate = moment(
    //   "2023-11-27T09:18:09.000Z")

    const eventTime =
      checkinDate && checkoutDate
        ? checkoutDate.isValid() && checkinDate.isValid()
          ? checkoutDate.diff(checkinDate, "minutes")
          : "--"
        : "--"
    const formattedEventTime =
      eventTime !== "--"
        ? eventTime % 60 === 0
          ? `${Math.floor(eventTime / 60)} hrs`
          : `${Math.floor(eventTime / 60)} hrs ${eventTime % 60} mins`
        : "--"


    return {
      _id: data._id,
      key: index,
      sNo: index + 1,
      leadNo: data.leadNo ? data.leadNo : "--",
      company: data.companyName ? data.companyName : "--",
      branch: data.branchName ? data.branchName : "--",
      clientCode: data.clientCode ? data.clientCode : "--",
      clientName: data.clientName ? data.clientName : "--",
      groomName: data.groomeName ? data.groomeName : "--",
      brideName: data.brideName ? data.brideName : "--",
      event: data.eventName ? data.eventName : "--",
      eventDate: data.eventDate ? moment(data.eventDate).format(dateFormat) : "--",
      venueLocation: data.venueLocation ? data.venueLocation : "--",
      venue: data.venueName ? data.venueName : "--",
      eventTime: formattedEventTime,
      checkinDate: data.PhotographerCheckInDateTime ? moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "",
      checkoutDate: data.PhotographerCheckOutDateTime ? moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "",
      clientFeedback: !isEmpty(data.clientReview) ? data.clientReview.remarks : "--",
      phtFeedback: !isEmpty(data.phtReview) ? data.phtReview.remarks : "--",
      phtFeedbackAttachment: !isEmpty(data.phtReview) ? data.phtReview.attachment : "",
      eventIssues: eventIssuesFeedback,
      eventIssuesAttachment: eventAttachment,
      freelancerQc: data.freelancerQc ? data.freelancerQc : [],
      checkinValue: data.PhotographerCheckInDateTime ? moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "--",
      checkoutValue: data.PhotographerCheckOutDateTime ? moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "--",
      clientAttachments: !isEmpty(data.clientReview) ? data.clientReview.attachment : "",



    }
  }) : []

  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead Number",
      editable: false,
      hidden: false,
      style: {
        color: "#E40D8C",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "clientCode",
      text: "Client Code",
      editable: false,
      hidden: false,
      style: {
        color: "#E40D8C",
      },
      headerStyle: {
        minWidth: "106px",
      },
    },

    {
      dataField: "clientName",
      text: "Client Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "event",
      text: "Event Name",
      hidden: false,
      csvExport: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },


    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },


    {
      dataField: "venueLocation",
      text: "Venue Location",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "165px",
      },
    },

    {
      dataField: "venue",
      text: "Venue",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "checkinValue",
      text: "Checkin Date & Time",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "checkoutValue",
      text: "Checkout Date & Time",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "eventTime",
      text: "Event Time",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "phtFeedback",
      text: "PHT Feedback",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "phtFeedbackAttachment",
      text: "PHT Feedback Attachment",
      editable: false,
      hidden: true,
      formatter: (cellContent, row) => {
        const attachCount =
          !isEmpty(row.phtFeedbackAttachment) && row.phtFeedbackAttachment.length > 0
            ? row.phtFeedbackAttachment.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(row.phtFeedbackAttachment) ? (
                  <a
                    onClick={() => {
                      setAttachmentModal(true)
                      setAttachmentDetails(row.phtFeedbackAttachment)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "203px",
      },
    },
    {
      dataField: "clientFeedback",
      text: "Client Feedback",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clientFeedbackAttachment",
      text: "Client Feedback Attachment",
      editable: false,
      hidden:true,
      formatter: (cellContent, row) => {
        const attachCount =
          !isEmpty(row.clientAttachments) && row.clientAttachments.length > 0
            ? row.clientAttachments.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(row.phtFeedbackAttachment) ? (
                  <a
                    onClick={() => {
                      setClientAttachmentModal(true)
                      setClientAttachmentDetails(row.clientAttachments)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "215px",
      },
    },
    {
      dataField: "eventIssues",
      text: "Event Issues",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventIssuesAttachment",
      text: "Event Issues Attachment",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        const attachments =
          !isEmpty(row.eventIssuesAttachment) && row.eventIssuesAttachment.length > 0
            ? row.eventIssuesAttachment[0]
            : ""
        return (<div>
          {!isEmpty(attachments) ? (
            <a
              onClick={() => window.open(attachments, "_blank")}
              rel="noopener noreferrer"
              className="mx-2 mt-2"
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View
              </span>
            </a>
          ) : (
            "--"
          )}</div>
        )
      },
      headerStyle: {
        minWidth: "190px",
      },
    },

    {
      dataField: "freelancerQc",
      text: "Freelancer Qc",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        const freeCount  = !isEmpty(row.freelancerQc)&&row.freelancerQc.length>0?
        row.freelancerQc.length:0
        return (
          <Button className="btn btn-info" onClick={() => {
            setFreelancerModal(true)
            setFreelancerData(row.freelancerQc)
          }}>
            Freelancer Qc
            <span className="badge rounded-pill ms-1" style={{
              backgroundColor:"black",color:"white"
            }}>
                  {freeCount}
                </span>
          </Button>
        )
      },
      headerStyle: {
        minWidth: "165px",
      },
    },

  ]
  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      savePhotoAction.loadPhoto({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,

      })
    )

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = company && company ? company.value : ""
    var searchBranch = branch && branch ? branches: ""
    var searchLeadNo = photoData && photoData ? photoData.leadNo : ""
    var searchEvent = event && event ? events: ""
    var searchFromDate =
      photoData && photoData.eventFromDate
        ? moment(photoData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      photoData && photoData.eventToDate
        ? moment(photoData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
  
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/audit_event_qc_report_expot_excel`, searchvalue)
      .then((response) => {
        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const eventIssuesFeedback = !isEmpty(data.eventIssue) ? data.eventIssue.map(m => m.remarks).join(",") : "--"

           

            const checkinDate = data.PhotographerCheckInDateTime
              ? moment(data.PhotographerCheckInDateTime)
              : ""
            // const checkinDate = moment(
            // "2023-11-27T06:18:09.000Z")
            const checkoutDate = data.PhotographerCheckOutDateTime
              ? moment(data.PhotographerCheckOutDateTime)
              : ""
            // const checkoutDate = moment(
            //   "2023-11-27T09:18:09.000Z")

            const eventTime =
              checkinDate && checkoutDate
                ? checkoutDate.isValid() && checkinDate.isValid()
                  ? checkoutDate.diff(checkinDate, "minutes")
                  : "--"
                : "--"
            const formattedEventTime =
              eventTime !== "--"
                ? eventTime % 60 === 0
                  ? `${Math.floor(eventTime / 60)} hrs`
                  : `${Math.floor(eventTime / 60)} hrs ${eventTime % 60} mins`
                : "--"
                const venueNameValue = !isEmpty(data.venueName)?JSON.stringify(data.venueName).replace(
                  /","/g,
                  "\n"
                ) :"--"
               const phtFeedback = !isEmpty(data.phtReview) ? data.phtReview.remarks : ""
                const phtFeedbackValue = !isEmpty(phtFeedback)
                ? phtFeedback.replace(/[\r\n,.]/gm, "")
                : "--"
              const clientFeedback = !isEmpty(data.clientReview) ? data.clientReview.remarks : ""
              const clientFeedbackValue =  !isEmpty(clientFeedback)
              ? clientFeedback.replace(/[\r\n,.]/gm, "")
              : "--"
            return {
              _id: data._id,
              key: index,
              sNo: index + 1,
              leadNo: data.leadNo ? data.leadNo : "--",
              company: data.companyName ? data.companyName : "--",
              branch: data.branchName ? data.branchName : "--",
              clientCode: data.clientCode ? data.clientCode : "--",
              clientName: data.clientName ? data.clientName : "--",
              groomName: data.groomeName ? data.groomeName : "--",
              brideName: data.brideName ? data.brideName : "--",
              event: data.eventName ? data.eventName : "--",
              eventDate: data.eventDate ? moment(data.eventDate).format(dateFormat) : "--",
              venueLocation: data.venueLocation ? data.venueLocation : "--",
              venue:venueNameValue,
              eventTime: formattedEventTime,
              checkinDate: data.PhotographerCheckInDateTime ? moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "",
              checkoutDate: data.PhotographerCheckOutDateTime ? moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "",
              clientFeedback: clientFeedbackValue,
              phtFeedback:  phtFeedbackValue ,
              eventIssues: eventIssuesFeedback,
              freelancerQc: data.freelancerQc ? data.freelancerQc : [],
              checkinValue: data.PhotographerCheckInDateTime ? moment(data.PhotographerCheckInDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "--",
              checkoutValue: data.PhotographerCheckOutDateTime ? moment(data.PhotographerCheckOutDateTime).format(`${dateFormat} ${"hh:mm A"}`) : "--",
             

            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,  Client Code ,Client Name, Groom Name,Bride Name,Event Name,Event Date,Venue Location,Venue,Checkin Date & Time,Checkout Date & Time,Event Time,PHT Feedback,Client Feedback,Event Issues",
          ]

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientCode,
                clientName,
                groomName,
                brideName,
                event,
                eventDate,
                venueLocation,
                venue,
                checkinValue,
                checkoutValue,
                eventTime,
                phtFeedback,
                clientFeedback,
                eventIssues,

              } = user
              acc.push([
                sNo,
                leadNo,
                clientCode,
                clientName,
                groomName,
                brideName,
                event,
                eventDate,
                venueLocation,
                venue,
                checkinValue,
                checkoutValue,
                eventTime,
                phtFeedback,
                clientFeedback,
                eventIssues,
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "GetPhotographerAppDetails.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 500)
        return response.data
      })
      .catch((error) => {
        setDownloadLoading(false)
        Promise.reject(error)})
    // }
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >

                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          wrapperClasses="table-responsive"
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: photo_data.length,
    data:
      !isEmpty(photo_data) && photo_data.length > 0
        ? photo_data.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(photo_data.data) && photo_data.data.length > 0
        ? photo_data.data
        : []
    if (
      !isEmpty(company) ||
      !isEmpty(branch) ||
      !isEmpty(event) ||
      !isEmpty(photoData.leadNo) ||
      !isEmpty(photoData.eventFromDate) ||
      !isEmpty(photoData.eventToDate)
    ) {
      var searchCompany = company && company ? company.value : ""
      var searchBranch = branch && branch ? branches : ""
      var searchLeadNo = photoData && photoData ? photoData.leadNo : ""
      var searchEvent = event && event ? events : ""
      var searchFromDate =
        photoData && photoData.eventFromDate
          ? moment(photoData.eventFromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        photoData && photoData.eventToDate
          ? moment(photoData.eventToDate).format("YYYY-MM-DD")
          : ""

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchEvent) {
        searchvalue.eventId = searchEvent
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      dispatch(savePhotoAction.loadPhoto(searchvalue))
    } else {
      dispatch(
        savePhotoAction.loadPhoto({
          page: page,
          limit: sizePerPage
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)

    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)


    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  const handleCompany = (e) => {
    setCompany(e)
    setBranch([])
  }


  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"App"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Lead No"}>
                          {"Lead No"}
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="leadNo"
                        value={photoData.leadNo}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Lead No"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => handleCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        isMulti
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchListOptions}
                        placeholder="Select Branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={photoData.eventFromDate}
                        max={photoData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={photoData.eventToDate}
                        min={photoData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event</Label>
                      <Select
                        type="text"
                        name="event"
                        isMulti
                        value={event}
                        onChange={(e) => setEvent(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <RemotePagination
                  data={photoTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={photo_data.totalDataCount}
                  onTableChange={handleTableChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {loading ? (
        <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {btnLoading ? (
        <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {/* {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span>
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )} */}
      {columnModal && (
        <Modal size="xl" show={columnModal}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Edit Columns
            <span>
              <i
                className="fa fa-times quote-close"
                aria-hidden="true"
                onClick={() => setColumnModal(false)}
              ></i>
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <div>
                <Input
                  type="checkbox"
                  checked={selectedColumns.length === columns.length}
                  onChange={(e) => handleSelectAllChange(e)}
                  style={{ width: "15px", height: "15px" }}
                />
                <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                  Select All
                </Label>
              </div>
            </Row>
            <Row>
              <Col sm="12" md="6" lg="6" className="ml-4">
                {oddColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
              <Col sm="12" md="6" lg="6">
                {evenColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <p
              className="text-decoration-underline text-info"
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={handleRestoreToDefault}
            >
              Restore To Default
            </p>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setColumnModal(false)
                setSelectedColumns(selectColumn)
              }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-success"
              onClick={() => handleSaveColumns()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
            {/* <span>Loading...</span> */}
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {attachmentModal && (
        <Modal show={attachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Pht Feedback Attachment
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(attachmentDetails) &&
                      attachmentDetails.length > 0 ? (
                      attachmentDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {clientAttachmentModal && (
        <Modal show={clientAttachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Client Feedback Attachment
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(clientAttachmentDetails) &&
                      clientAttachmentDetails.length > 0 ? (
                      clientAttachmentDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setClientAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
   
      {freelancerModal && (
        <Modal show={freelancerModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Freelancer Qc
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Freelancer Name</th>
                      <th>Service </th>
                      <th>Star Rating</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(freelancerData) &&
                      freelancerData.length > 0 ? (
                      freelancerData.map((data, index) => {

                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {data.freelancerShooterName?
                                data.freelancerShooterName:"--"}
                              </td>
                              <td>{data.serviceName?data.serviceName:"--"}</td>
                              <td>{data.ratings?data.ratings:"--"}</td>
                              <td>{data.remarks}</td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={5} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setFreelancerModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
GetPhotographerAppDetails.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GetPhotographerAppDetails)
)
